export default "__VITE_ASSET__GM97fv2T__"